export default __webpack_public_path__ + "a928dffe150e05a117d86efb9d5b88cd.png";